import React, { useMemo } from 'react';
import { useLocale } from '@/shared/hooks/use-locale';
import { tp } from '@/shared/lib/typograf';
import Typografed from '../../shared/Typografed';

export type ServiceCarAccreditationProps = {
    cards: {
        id: number;
        price: string;
        slug: string;
        description: string;
    }[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    carAccreditation: ServiceCarAccreditationProps;
};

export default function ServiceCarAccreditation({ carAccreditation }: Props) {
    return (
        <div className="car-accreditation wrapper">
            {carAccreditation.cards.length > 0 ? (
                <ul className="car-accreditation__list list-unstyled">
                    {carAccreditation.cards.map((card) => (
                        <li className="car-accreditation__item" key={card.id}>
                            <CarAccreditationItem price={card.price} description={card.description} />
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="car-accreditation__empty">
                    <Typografed>Варианты аккредитации не найдены</Typografed>
                </div>
            )}
        </div>
    );
}

const CarAccreditationItem = ({ price, description }: { price: string; description: string }) => {
    const locale = useLocale();
    const tpPrice = useMemo(() => tp(price || '', locale), [price, locale]);
    const tpDescription = useMemo(() => tp(description || '', locale), [description, locale]);

    return (
        <>
            {tpPrice && <span className="car-accreditation__price text-xl">{tpPrice}</span>}
            {tpDescription && <span className="car-accreditation__description text-s">{tpDescription}</span>}
        </>
    );
};
